import { render, staticRenderFns } from "./IsoIPP.vue?vue&type=template&id=647ba669&scoped=true"
import script from "./IsoIPP.vue?vue&type=script&lang=js"
export * from "./IsoIPP.vue?vue&type=script&lang=js"
import style0 from "./IsoIPP.vue?vue&type=style&index=0&id=647ba669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ba669",
  null
  
)

export default component.exports